import {
  FunctionComponent,
  RefAttributes,
  PropsWithoutRef,
  ForwardRefExoticComponent,
} from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'
import { Link as ThemeUILink, LinkProps as ThemedUILinkProps } from 'theme-ui'

// Ripped from @types/theme-ui__components
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/86bd530585927c9a4e16bc8f5db17439b66c30b3/types/theme-ui__components/index.d.ts#L21
type ForwardRef<T, P> = ForwardRefExoticComponent<
  PropsWithoutRef<P> & RefAttributes<T>
>

type CombinedProps = ThemedUILinkProps & RouterLinkProps<{}>

const FinalLink: ForwardRef<HTMLAnchorElement, CombinedProps> = ThemeUILink

export const Link: FunctionComponent<CombinedProps> = ({
  children,
  ...props
}) => {
  return (
    <FinalLink as={RouterLink} {...props}>
      {children}
    </FinalLink>
  )
}
